import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './components/App/App';
import { BrowserRouter } from 'react-router-dom';

function migrateLegacyHashRoute() {
  if (!window.location.hash.startsWith('#/')) {
    return;
  }

  const targetUrl = new URL(window.location.hash.slice(1), window.location.origin);
  const currentSearchParams = new URLSearchParams(window.location.search);

  currentSearchParams.forEach((value, key) => {
    targetUrl.searchParams.append(key, value);
  });

  window.history.replaceState(
    null,
    '',
    `${targetUrl.pathname}${targetUrl.search}`
  );
}

migrateLegacyHashRoute();

const app = (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
const rootElement = document.getElementById('root');

ReactDOM.createRoot(rootElement).render(app);
